import React, { useState } from 'react';
import PropTypes from 'prop-types';
import constants from '../constants/constants';

const AppContext = React.createContext([{}, () => {}]);

const AppProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    fontLink: constants.fontStyle.fontLink,
    fontFamily: constants.fontStyle.fontFamily
  });

  return (
    <AppContext.Provider value={[settings, setSettings]}>
      {children}
    </AppContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { AppContext, AppProvider };
